import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner3.png'
import _imports_2 from '../../assets/performance/banner9.png'
import _imports_3 from '../../assets/performance/banner.png'
import _imports_4 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-191752da")

_pushScopeId("data-v-191752da")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = { style: {"display":"flex"} }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "按任务生成报告", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_14 = { class: "dialogTitle" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_18 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createVNode("div", {
  class: "versionGeneration versionGeneration2",
  style: {}
}, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b")
  ])
], -1)
const _hoisted_29 = { id: "perf_report" }
const _hoisted_30 = { class: "spacName" }
const _hoisted_31 = {
  key: 0,
  class: "banner",
  src: _imports_1,
  alt: ""
}
const _hoisted_32 = {
  key: 1,
  class: "banner",
  src: _imports_2,
  alt: ""
}
const _hoisted_33 = {
  key: 2,
  class: "banner",
  src: _imports_3,
  alt: ""
}
const _hoisted_34 = { class: "spacName" }
const _hoisted_35 = { class: "gameTable" }
const _hoisted_36 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_37 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 版本: ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_42 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试内容: "),
  /*#__PURE__*/_createVNode("span", null, "UI&关卡性能")
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_44 = { style: {"margin-bottom":"20px"} }
const _hoisted_45 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试概括")
], -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("测试内容")
], -1)
const _hoisted_47 = { class: "spacName" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("(上次")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("，")
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、详细机型测试数据")
], -1)
const _hoisted_54 = { style: {"color":"#2b64bb","font-weight":"bold"} }
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_56 = { style: {"width":"100%","overflow-x":"auto"} }
const _hoisted_57 = {
  style: {"margin-top":"8px"},
  class: "gameTable1"
}
const _hoisted_58 = { style: {"background":"#5d99d5"} }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.report_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          style: {"width":"500px"}
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManuallyByTask,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode("div", null, [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          onClick: _ctx.clear,
                          disabled: _ctx.get_is_super,
                          style: {"height":"28px","margin-left":"10px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "暂无管理员权限",
                              placement: "top",
                              disabled: !_ctx.get_is_super
                            }, {
                              default: _withId(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "890px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("span", null, [
                          _hoisted_15,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                modelValue: _ctx.generateReportVersion.old_Edition,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.generateReportVersion.old_Edition = $event)),
                                id: "old_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                modelValue: _ctx.generateReportVersion.Edition,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateReportVersion.Edition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试类型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.reportType,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.generateReportVersion.reportType = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.test_type, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.name,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "是否触发机器人" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.generateReportVersion.robot,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.generateReportVersion.robot = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_19,
                                    _hoisted_20,
                                    _hoisted_21,
                                    _hoisted_22,
                                    _hoisted_23,
                                    _hoisted_24,
                                    _hoisted_25
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[15] || (_cache[15] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_26
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_27
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"]),
                        _hoisted_28
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_29, [
                    _withDirectives(_createVNode("div", _hoisted_30, [
                      (
                  _ctx.localProject === 34 ||
                  _ctx.localProject === 40 ||
                  _ctx.localProject === 47
                )
                        ? (_openBlock(), _createBlock("img", _hoisted_31))
                        : (_ctx.localProject === 59)
                          ? (_openBlock(), _createBlock("img", _hoisted_32))
                          : (_openBlock(), _createBlock("img", _hoisted_33))
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _withDirectives(_createVNode("table", _hoisted_35, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_36, [
                            _createVNode("img", {
                              src: _ctx.get_skin_data.project.icon
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("td", _hoisted_37, " 【" + _toDisplayString(_ctx.get_skin_data.project.project_name) + "】 ", 1)
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_38,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.version), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_39,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.date), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_40,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.creator), 1)
                          ])
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_41,
                            _createVNode("span", {
                              style: {
                          color: _ctx.riskLv === '高风险' ? 'red' : '#00b050',
                        }
                            }, [
                              _createVNode("b", null, _toDisplayString(_ctx.riskLv), 1)
                            ], 4)
                          ]),
                          _hoisted_42,
                          _createVNode("td", null, [
                            _hoisted_43,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data?.device_type), 1)
                          ])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.report_loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _hoisted_46,
                      _withDirectives(_createVNode("div", _hoisted_47, [
                        _createVNode(_component_el_table, {
                          "header-cell-style": {
                      background: '#f5f7fa',
                      height: '31px',
                      padding: '0px',
                      fontWeight: 'bold',
                      color: '#303133',
                    },
                          data: _ctx.risk_list
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "性能数据变化情况"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  width: "160",
                                  label: "机型"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.risk_thead, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    width: item != '性能指标*内存峰值' ? 220 : 300,
                                    key: index,
                                    label: item
                                  }, {
                                    default: _withId((scope) => [
                                      (scope.row.value[item]?.length != 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_48, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.value[item], (k, i) => {
                                              return (_openBlock(), _createBlock("div", { key: i }, [
                                                _createTextVNode(_toDisplayString(i + 1) + "、" + _toDisplayString(k.label), 1),
                                                _createVNode("span", {
                                                  style: 'margin-left:5px;color:' + k.new_color
                                                }, _toDisplayString(k.new), 5),
                                                _hoisted_49,
                                                _createVNode("span", null, _toDisplayString(k.old), 1),
                                                _hoisted_50,
                                                _createVNode("span", {
                                                  style: 'color:' + k.diff_color
                                                }, _toDisplayString(k.res) + ")", 5)
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createBlock("div", _hoisted_51, "各场景变化不大"))
                                    ]),
                                    _: 2
                                  }, 1032, ["width", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ], 512), [
                        [_directive_loading, _ctx.report_loading]
                      ]),
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _ctx.scene_change,
                                modelValue: _ctx.draw_scene,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.draw_scene = $event)),
                                placeholder: "请选择",
                                clearable: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.all_echart_data.map(
                          (v) => v.scene
                        ), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onChange", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.drawList, (item, index) => {
                        return _withDirectives((_openBlock(), _createBlock("div", {
                          style: {"margin-bottom":"10px"},
                          key: index
                        }, [
                          _createVNode("h6", null, [
                            _hoisted_52,
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _createVNode(_component_el_card, null, {
                            default: _withId(() => [
                              _createVNode("div", {
                                id: _ctx.draw_scene + item.value,
                                style: {"width":"100%","height":"350px"}
                              }, null, 8, ["id"])
                            ]),
                            _: 2
                          }, 1024)
                        ], 512)), [
                          [_directive_loading, _ctx.report_loading]
                        ])
                      }), 128))
                    ]),
                    _hoisted_53,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.model_list, (value, key, index) => {
                      return _withDirectives((_openBlock(), _createBlock("div", {
                        style: {"margin-top":"8px"},
                        key: index
                      }, [
                        _createVNode("h6", _hoisted_54, [
                          _hoisted_55,
                          _createTextVNode(" " + _toDisplayString(key), 1)
                        ]),
                        _createVNode("div", _hoisted_56, [
                          _createVNode("table", _hoisted_57, [
                            _createVNode("thead", _hoisted_58, [
                              _createVNode("tr", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gameList(value), (item) => {
                                  return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                                }), 128))
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.data, (item, k) => {
                              return (_openBlock(), _createBlock("tbody", { key: k }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (v, i) => {
                                  return (_openBlock(), _createBlock("tr", { key: i }, [
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 0,
                                          rowspan: item.length
                                        }, _toDisplayString(v.hero_name), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    _createVNode("td", null, _toDisplayString(v.skin_name), 1),
                                    (_ctx.localProject == 59)
                                      ? (_openBlock(), _createBlock("td", _hoisted_59, _toDisplayString(v.level_id || '--'), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_num(
                                'avg_fps',
                                v.avg_fps,
                                value.model_level,
                                value.model_type
                              )
                            
                                      }, _toDisplayString(v.avg_fps), 5),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor('avg_fps', v.avg_fps, v.old.avg_fps)
                            
                                      }, _toDisplayString(_ctx.getNum(v.avg_fps, v.old.avg_fps, "avg_fps")[0]), 5)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: {color: _ctx.compore_num('jank', v.jank, value.model_level, value.model_type)}
                                      }, _toDisplayString(v.jank || '-'), 5),
                                      _createVNode("span", {
                                        style: {color: _ctx.getColor('jank', v['jank'], v.old['jank'])}
                                      }, _toDisplayString(_ctx.getNum(v['jank'], v.old['jank'], "jank")[0]), 5)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: {color: _ctx.compore_num('fps_lt_25_pcnt', v.fps_lt_25_pcnt, value.model_level, value.model_type)}
                                      }, _toDisplayString(v.fps_lt_25_pcnt || '-') + "%", 5),
                                      _createVNode("span", {
                                        style: {color: _ctx.getColor('fps_lt_25_pcnt', v['fps_lt_25_pcnt'], v.old['fps_lt_25_pcnt'])}
                                      }, _toDisplayString(_ctx.getNum(v['fps_lt_25_pcnt'], v.old['fps_lt_25_pcnt'], "fps_lt_25_pcnt")[0]), 5)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: {color: _ctx.compore_num('fps_lt_18_pcnt', v.fps_lt_18_pcnt, value.model_level, value.model_type)}
                                      }, _toDisplayString(v.fps_lt_18_pcnt || '-') + "%", 5),
                                      _createVNode("span", {
                                        style: {color: _ctx.getColor('fps_lt_18_pcnt', v['fps_lt_18_pcnt'], v.old['fps_lt_18_pcnt'])}
                                      }, _toDisplayString(_ctx.getNum(v['fps_lt_18_pcnt'], v.old['fps_lt_18_pcnt'], "fps_lt_18_pcnt")[0]), 5)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_num(
                                'avg_cpu',
                                v.avg_cpu,
                                value.model_level,
                                value.model_type
                              )
                            
                                      }, _toDisplayString(v.avg_cpu), 5),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor('avg_cpu', v.avg_cpu, v.old.avg_cpu)
                            
                                      }, _toDisplayString(_ctx.getNum(v.avg_cpu, v.old.avg_cpu, "avg_cpu")[0]), 5)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_num(
                                'max_pss',
                                v.max_pss,
                                value.model_level,
                                value.model_type
                              )
                            
                                      }, _toDisplayString(v.max_pss), 5),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor('max_pss', v.max_pss, v.old.max_pss)
                            
                                      }, _toDisplayString(_ctx.getNum(v.max_pss, v.old.max_pss, "max_pss")[0]), 5)
                                    ]),
                                    (value?.model_type != 1)
                                      ? (_openBlock(), _createBlock("td", _hoisted_60, [
                                          _createVNode("span", {
                                            style: 
                                'color:' +
                                _ctx.compore_num(
                                  'GUsage',
                                  v.GUsage,
                                  value.model_level,
                                  value.model_type
                                )
                              
                                          }, _toDisplayString(v.GUsage), 5),
                                          _createVNode("span", {
                                            style: 
                                'color:' +
                                _ctx.getColor('gpu_usage', v.GUsage, v.old.GUsage)
                              
                                          }, _toDisplayString(_ctx.getNum(v.GUsage, v.old.GUsage, "GUsage")[0]), 5)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor('DrawCall', v.DrawCall, v.old.DrawCall)
                            
                                      }, _toDisplayString(v.DrawCall), 5),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor(
                                'DrawCall_change',
                                v.DrawCall,
                                v.old.DrawCall
                              )
                            
                                      }, _toDisplayString(_ctx.getNum(v.DrawCall, v.old.DrawCall, "DrawCall")[0]), 5)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor(
                                'Primitives',
                                v.Primitives,
                                v.old.Primitives
                              )
                            
                                      }, _toDisplayString(v.Primitives), 5),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.getColor(
                                'Primitives_change',
                                v.Primitives,
                                v.old.Primitives
                              )
                            
                                      }, _toDisplayString(_ctx.getNum(
                                v.Primitives,
                                v.old.Primitives,
                                "Primitives"
                              )[0]), 5)
                                    ]),
                                    (_ctx.localProject != 59)
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                          (value?.model_type != 1)
                                            ? (_openBlock(), _createBlock("td", _hoisted_61, [
                                                _createVNode("span", {
                                                  style: 
                                'color:' +
                                _ctx.compore_num(
                                  'GPU_General_Clocks',
                                  v.GPU_General_Clocks,
                                  value.model_level,
                                  value.model_type
                                )
                              
                                                }, _toDisplayString(v.GPU_General_Clocks), 5),
                                                _createVNode("span", null, _toDisplayString(_ctx.getNum(
                                v.GPU_General_Clocks,
                                v.old.GPU_General_Clocks,
                                "GPU_General_Clocks"
                              )[0]), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (value?.model_type != 1)
                                            ? (_openBlock(), _createBlock("td", _hoisted_62, [
                                                _createVNode("span", {
                                                  style: 
                                'color:' +
                                _ctx.compore_num(
                                  'MAX_GPU_General_Clocks',
                                  v.MAX_GPU_General_Clocks,
                                  value.model_level,
                                  value.model_type
                                )
                              
                                                }, _toDisplayString(v.MAX_GPU_General_Clocks), 5),
                                                _createVNode("span", null, _toDisplayString(_ctx.getNum(
                                v.MAX_GPU_General_Clocks,
                                v.old.MAX_GPU_General_Clocks,
                                "MAX_GPU_General_Clocks"
                              )[0]), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    _createVNode("td", null, [
                                      _createVNode("a", {
                                        href: _ctx.get_url(v['链接']),
                                        target: "_blank"
                                      }, " 链接 ", 8, ["href"])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 512)), [
                        [_directive_loading, _ctx.report_loading]
                      ])
                    }), 128))
                  ])
                ]),
                _hoisted_63
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})